import { render, staticRenderFns } from "./AdminEbDashboard.vue?vue&type=template&id=d776aa7e"
import script from "./AdminEbDashboard.vue?vue&type=script&lang=js"
export * from "./AdminEbDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports